import React from 'react'
import styled from 'styled-components'
import { PlusCircle } from '@styled-icons/bootstrap'

const ContainerAccordeon = styled.div`
    border-bottom: 3px solid #EFEFEF;
`

const AcordeonHeader = styled.div<{ show: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    > div h5{
        color: ${p => p.show ? '#FEA500' : '#5E5D5D'};
    }

    > div svg{
        color: ${p => p.theme.palette.primary.main};
        width: 20px;
    }
`

const AccordeonBody = styled.div<{ show: boolean }>`
    height: ${p => p.show ? '120px' : '0px'};
    transition: .5s;
    overflow: hidden;
`

interface IOwnProps{
    active: boolean
    title: string;
    description: string;
}

const ItemAccoreon: React.FunctionComponent<IOwnProps> = ({ active, title, description }) => {
    const [ show, setShow ] = React.useState(active)
    const handleShow = () => setShow(!show)

  return (
    <ContainerAccordeon>
        <AcordeonHeader show={show} onClick={handleShow}>
            <div><h5>{title}</h5></div>
            <div><PlusCircle /></div>
        </AcordeonHeader>
        <AccordeonBody show={show}>{description}</AccordeonBody>
    </ContainerAccordeon>
  )
}

export default ItemAccoreon